import { faker } from '@faker-js/faker/locale/en';
import type { DealAdCategoryProposal } from './model';
import { DealAdCategoryProposalStatus } from './model';

// this is just temporary to solve i18next not translating properly during runtime
const hardcodedCategories: string[] = [
  'Alcohol',
  'Cannabis & Cannabis Products',
  'Gambling (Online)',
  'Government',
  'Healthcare',
  'Intimate Apparel',
  'Legal',
  'Lotteries (state-sponsored)',
  'Pharmaceutical',
  'Politics',
  'Religion',
  'Sexual Health',
  'Software',
  'Tobacco & Smoking Products',
];

const STATUSES = Object.values(DealAdCategoryProposalStatus);

function fakeDealAdCategoryProposalFactory(): DealAdCategoryProposal {
  const dealId = faker.string.numeric(8);
  const status = faker.helpers.arrayElement(STATUSES);
  const proposedDate = faker.date.past();

  return {
    id: faker.string.uuid(),
    revision: 1,
    dealId,
    proposedAdCategory: faker.helpers.arrayElement(hardcodedCategories),
    status,
    categoryBids: faker.number.int({ min: 20, max: 1000000 }),
    categoryBidShare: faker.number.float({ min: 0, max: 1 }),
    classifiedBids: faker.number.int({ min: 20, max: 1000000 }),
    windowStart: faker.date.past().toISOString().split('T')[0],
    windowEnd: faker.date.recent().toISOString().split('T')[0],
    proposedDate: proposedDate.toISOString(),
    decisionDate: status === DealAdCategoryProposalStatus.Pending ? null : faker.date.recent().toISOString(),
    deal: {
      dealId,
      name: faker.commerce.productName(),
      account: {
        name: faker.company.name(),
      },
    },
  };
}

export const fakeDealAdCategoryProposals: DealAdCategoryProposal[] = Array.from(
  { length: 12 },
  fakeDealAdCategoryProposalFactory
);
